module.exports = __webpack_public_path__ + "sahara-ed941390170aa1517058eb7f0f8c1c3f.png";